var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowFc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.176,
    height: 11.856,
    viewBox: "0 0 24.176 11.856",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_7282",
    "data-name": "Path 7282",
    d: "M-17531.5-5776.2l11-10.8,12.5,10.8",
    transform: "translate(17531.85 5787.679)",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowFc);
export default __webpack_public_path__ + "static/media/arrowFc.8061aa5d0a148146ace71b07d2f4af58.svg";
export { ForwardRef as ReactComponent };